// extracted by mini-css-extract-plugin
export var bodyGrid = "ChildMenuItemTile-module--body-grid--4f815";
export var centerAlignedBody = "ChildMenuItemTile-module--centerAlignedBody--17793";
export var childMenuItemTile = "ChildMenuItemTile-module--child-menu-item-tile--a791a";
export var icon = "ChildMenuItemTile-module--icon--07e7f";
export var sectionGrid = "ChildMenuItemTile-module--sectionGrid--7a2de";
export var sectionGridAlignCenter = "ChildMenuItemTile-module--sectionGridAlignCenter--fb91c";
export var text = "ChildMenuItemTile-module--text--4a761";